import React from "react";
import { THEME_COLORS } from "../../../../../color";
import { useSelector } from "react-redux";
// Utility to convert hex to RGBA with transparency
const hexToRgba = (hex, alpha = 0.2) => {
  const bigint = parseInt(hex.replace("#", ""), 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const InfoCard = ({ title, items }) => {
  const colorCycle = [
    THEME_COLORS.green,
    THEME_COLORS.pink,
    THEME_COLORS.lightblue,
  ];
  const { user } = useSelector((state) => state.auth);
  const isPermissionCompleted = user?.isCompleted;
  //console.log(isPermissionCompleted, "isPermissionCompleted");

  return (
    <div
      className={`border border-[#3da3baa9] rounded-xl p-3 sm:p-4 md:p-5 w-full max-w-full ${
        !isPermissionCompleted ? "blur-sm opacity-60 pointer-events-none" : ""
      }`}
    >
      {/* Card Title */}
      <h3
        className="text-xs sm:text-sm md:text-base font-semibold mb-3"
        style={{ color: THEME_COLORS.green }}
      >
        {title}
      </h3>

      {/* Item Rows */}
      <div className="space-y-2">
        {items.map((item, index) => {
          const color = colorCycle[index % colorCycle.length];
          const lightBg = hexToRgba(color, 0.2);

          return (
            <div
              key={index}
              className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 sm:gap-4"
            >
              {/* Label */}
              <div
                className="rounded-full text-[11px] sm:text-[12px] md:text-sm font-bold px-3 py-1 sm:w-20 text-center"
                style={{
                  backgroundColor: lightBg,
                  border: `1px solid ${color}`,
                  color: color,
                }}
              >
                {item.value}
              </div>
              <div
                className="w-full sm:flex-1 py-1 px-3 rounded-md text-xs sm:text-sm border"
                style={{
                  borderColor: color,
                }}
              >
                {item.label}
              </div>

              {/* Value Badge */}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default InfoCard;
